

    /**
     * Typecast a value to a String, using an empty string value for null or
     * undefined.
     */
    function toString(val){
        return val == null ? '' : val.toString();
    }

    module.exports = toString;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/lang/toString.js
// module id = 177
// module chunks = 1